import React, { useEffect, useState, useRef } from "react";
import { API } from "../Axios/Axios";
import { Modal, Select } from "antd";

const { Option } = Select;

type Task = {
  Id: number;
  IsActive: boolean;
  actionTaken: string | null;
  dueDate: string;
  lastEscalationTime: string | null;
  lastReminderTime: string | null;
  principleId: number;
  principleType: string;
  remarks: string | null;
  roleId: number | null;
  stageId: number;
  taskId: number | null;
  taskOutcome: string | null;
  taskOutcomeId: number;
  taskStatus: string | null;
  taskStatusId: number;
  taskType: string | null;
  title: string;
  transactionId: number | null;
  transactionType: string | null;
  userId: number | null;
  workflowInstanceId: number;
  workflowName: string | null;
};

const WorkflowScreen: React.FC = () => {
  const [tasks, setTasks] = useState<Task[]>([]);
  const [wfitasks, setWfitasks] = useState<Task[]>([]);
  const [loading, setLoading] = useState(false);

  const [workflowId] = useState("12"); // Fixed Workflow ID
  const [transactionType] = useState("EmployeeOnboarding"); // Fixed Transaction Type
  const [transactionId, setTransactionId] = useState("");
  const [workflowInstanceId, setWorkflowInstanceId] = useState("");

  const [newInput1, setNewInput1] = useState("");
  const [newInput2, setNewInput2] = useState("");

  const [taskId, setTaskId] = useState<number | undefined>();
  const [taskOutcomeId, setTaskOutcomeId] = useState<string | null>(null);

  const newIdRef = useRef(1); // Persistent transaction ID simulation
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [customAction, setCustomAction] = useState('');

  useEffect(() => {
    if (tasks.length > 0) {
      setWorkflowInstanceId(tasks[0].workflowInstanceId.toString());
    }
  }, [tasks]);

  useEffect(() => {
    GetAllTasks();
  }, []);

  const GetAllTasks = async () => {
    const formData = {
      CreatedBy: 6,
      WorkflowInstanceId: parseInt(workflowInstanceId) || 0,
    };

    try {
      const response = await API.post("/Tasks/GetAllTasks", formData);
      const tasksArray = response.data.data;

      if (Array.isArray(tasksArray)) {
        setTasks(tasksArray);
      } else {
        console.warn("Unexpected tasks response format:", response.data);
        setTasks([]);
      }
    } catch (error) {
      console.error("GetAllTasks failed:", error);
    }
  };

  const StartWorkflow = async () => {
    const formData = {
      WorkflowId: parseInt(workflowId),
      TransactionId: parseInt(transactionId),
      TransactionType: transactionType,
      CreatedBy: 6,
    };

    try {
      setLoading(true);
      const response = await API.post("/Workflow/StartWorkflow", formData);
      console.log("Workflow started:", response.data);
      setWorkflowInstanceId(response.data.data[0].workflowInstanceId);
      console.log(response.data.data[0].workflowInstanceId);
       
      setTransactionId(""); // Clear after use
    } catch (error) {
      console.error("StartWorkflow failed:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if(workflowInstanceId != null && workflowInstanceId != "")
    {
      GetAllTasks();
    }
  }, [workflowInstanceId])

  const UpdateTask = async (taskId: number, outcome: string, isCustomAction: any) => {
    const formData = {
      TaskId: taskId,
      TaskOutcome: outcome,
      DueDate: null,
      CreatedBy: 14,
      Remarks: "Updated via UI",
      isCustomAction: isCustomAction ?? 0
    };

    try {
      const response = await API.post("/Tasks/UpdateTask", formData);
      console.log("Task updated:", response.data);

      if (response.data?.data?.[0]?.message) {
        alert(response.data.data[0].message);
      }

      setTaskId(taskId);
      setTaskOutcomeId(outcome);
      await GetAllTasks();
    } catch (error) {
      console.error("UpdateTask failed:", error);
    }
  };

  const SendbackTask = async (taskId: number, outcome: string, isCustomAction: any) => {
    const formData = {
      TaskId: taskId,
      TaskOutcome: "SENDBACK",
      DueDate: null,
      CreatedBy: 14,
      Remarks: "Updated via UI",
      StageSystemName: 'AuditHeadObservationAcceptance',
      isCustomAction: isCustomAction
    };

    try {
      const response = await API.post("/Tasks/UpdateTask", formData);
      console.log("Task sentback:", response.data);
      
      if (response.data?.data?.[0]?.msg) {
        alert(response.data.data[0].msg);
      }

      setTaskId(taskId);
      setTaskOutcomeId(outcome);
      await GetAllTasks();
    } catch (error) {
      console.error("UpdateTask failed:", error);
    }
  };

  const JumpToStage = async (isCustomAction: any) => {
    const formData = {
      WorkflowInstanceId: parseInt(workflowInstanceId) || 0,
      StageSystemName: 'HODFunctionalObservationAcceptance',
      CreatedBy: 14,
      TerminateCurrentTask: false,
      isCustomAction: isCustomAction
    };

    try {
      const response = await API.post("/Workflow/JumpToStage", formData);
      console.log(response);

      if (response.data?.data?.[0]?.msg) {
        alert(response.data.data[0].msg);
      }

      await GetAllTasks();
    } catch (error) {
      console.error("JumpToStage failed:", error);
    }
  };

   
  const MoveToNextWorkflow = async (isCustomAction: any) => {
    const formData = {
      WorkflowInstanceId: parseInt(workflowInstanceId) || 0,
      Action: taskOutcomeId ?? 'Completed',
      CreatedBy: 14,
      TerminateCurrentTask: false,
      CurrentTaskId: taskId,
      isCustomAction: isCustomAction ?? 0
    };

    try {
      const response = await API.post("/Workflow/MoveToNextStage", formData);
      console.log(response);

      if (response.data?.data?.[0]?.msg) {
        alert(response.data.data[0].msg);
      }

      await GetAllTasks();
    } catch (error) {
      console.error("MoveToNextStage failed:", error);
    }
  };

  const handleSaveTransaction = async () => {
    try {
      if (newIdRef.current) {
        setTransactionId(newIdRef.current.toString());
        alert(`Transaction saved successfully. ID: ${newIdRef.current}`);
        newIdRef.current += 1;
      } else {
        alert("Transaction saved, but ID not returned.");
      }
    } catch (error) {
      console.error("Save transaction failed:", error);
      alert("Failed to save transaction.");
    }
  };

  const taskStatusMapById: { [key: number]: string } = {
    1: "Pending",
    3: "Rejected",
    4: "Completed",
    5: "Skipped",
    6: "Terminated",
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  useEffect(() => {
    if(isModalOpen)
    {
      (async () => {

        const GetAllWFITasks = async () => {
          const formData = {
            CreatedBy: 6,
            WorkflowInstanceId: parseInt(workflowInstanceId) || 0,
          };
      
          try {
            const response = await API.post("/Tasks/GetAllCurrentCustomStageTasks", formData);
            const tasksArray = response.data.data;
      
            if (Array.isArray(tasksArray)) {
              setWfitasks(tasksArray);
            } else {
              console.warn("Unexpected tasks response format:", response.data);
              setWfitasks([]);
            }
          } catch (error) {
            console.error("GetAllTasks failed:", error);
          }
        };
        await GetAllWFITasks();
      })();
    }

  }, [isModalOpen])

  const handleOk = () => {
    setIsModalOpen(false);
    if(customAction === 'MoveToNext')
    {
      MoveToNextWorkflow(1);
    } else if(customAction === 'JumpToStage')
    {
      JumpToStage(1);
    } else if (customAction === 'Reject')
    {
      let index = (wfitasks.length) - 1;
      let taskId = wfitasks[index].taskId?.toString() ?? '0';
      UpdateTask(parseInt(taskId), "Rejected", 1);
    } else if(customAction === 'Sendback')
    {
      let index = (wfitasks.length) - 1;
      let taskId = wfitasks[index].taskId?.toString() ?? '0';
      SendbackTask(parseInt(taskId), "Sendback", 1);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleCustomStageActionChange = (value: any) => {
    setCustomAction(value);
  }

  const GetWorkflowInstanceHistory = async () => {
    const formData = {
      WorkflowInstanceId: parseInt(workflowInstanceId) || 0,
    };

    try {

      const response = await API.post("/Workflow/GetWorkflowHistory", formData);
      console.log(response);

    } catch (error) {
      console.error("GetWorkflowHistory failed:", error);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <center>
        <h4>Workflow Manager</h4>
      </center>

      <h5>Transaction Details</h5>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "10px",
          flexWrap: "wrap",
        }}
      >
        <input
          type="text"
          placeholder="Reason for Leave"
          value={newInput1}
          onChange={(e) => setNewInput1(e.target.value)}
          style={{ padding: "5px", width: "150px" }}
        />
        <input
          type="date"
          placeholder="Date"
          value={newInput2}
          onChange={(e) => setNewInput2(e.target.value)}
          style={{ padding: "5px", width: "150px" }}
        />
        <button
          onClick={handleSaveTransaction}
          disabled={!newInput1.trim() || !newInput2.trim()}
          style={{ padding: "6px 12px" }}
        >
          Save Transaction
        </button>
        <label>
          <b>Transaction ID:</b> {transactionId || "N/A"}
        </label>
      </div>

      <h5>Workflow Details</h5>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "20px",
          flexWrap: "wrap",
        }}
      >
        <input
          type="number"
          value={workflowId}
          disabled
          style={{ padding: "5px", width: "120px", backgroundColor: "#f2f2f2" }}
        />
        <input
          type="number"
          value={transactionId}
          onChange={(e) => setTransactionId(e.target.value)}
          disabled={loading}
          style={{ padding: "5px", width: "120px" }}
        />
        <input
          type="text"
          value={transactionType}
          disabled
          style={{ padding: "5px", width: "150px", backgroundColor: "#f2f2f2" }}
        />
        <button
          onClick={StartWorkflow}
          disabled={
            loading ||
            !workflowId.trim() ||
            !transactionId.trim() ||
            !transactionType.trim()
          }
          style={{ padding: "6px 12px" }}
        >
          {loading ? "Starting..." : "Start Workflow"}
        </button>
        <button
          onClick={() => {
            MoveToNextWorkflow(0)
          } }
          style={{ padding: "6px 11px" }}
          
        >
          Move to Next Stage
        </button>

        <button
          onClick={() => {
            JumpToStage(0)
          }}
          style={{ padding: "6px 11px" }}
          
        >
          Jump To Stage
        </button>

        <button 
          onClick={GetWorkflowInstanceHistory}
          style={{ padding: "6px 11px" }}
          >
          Instance History
        </button>

        <button 
          onClick={showModal}
          style={{ padding: "6px 11px" }}
          >
          Custom
        </button>
          <Modal
            title="Custom Stage"
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            okText="Submit"
            cancelText="Cancel"
          >
            {wfitasks.length === 0 ? (
              <p>No tasks found.</p>
            ) : (
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  marginTop: "10px",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#f2f2f2" }}>
                    <th style={thStyle}>ID</th>
                    <th style={thStyle}>User ID</th>
                    <th style={thStyle}>Title</th>
                    <th style={thStyle}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {wfitasks.map((task) => {
                    const statusText =
                      taskStatusMapById[task.taskStatusId] || "Unknown";

                    return (
                      <tr
                        key={task.taskId ? `task-${task.taskId}` : `id-${task.Id}`}
                        style={{ cursor: "pointer" }}
                      >
                        <td style={tdStyle}>{task.taskId ?? task.Id}</td>
                        <td style={tdStyle}>{task.userId ?? task.Id}</td>
                        <td style={tdStyle}>{task.title}</td>
                        <td style={tdStyle}>{statusText}</td>

                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
            <br></br>
            <p>Select Custom Action</p>
            <br></br>
            <Select
              placeholder="Select an Action"
              style={{ width: "100%" }}
           
              onChange={async (value: any) => {
                handleCustomStageActionChange(value);
              }}
            >
              <Option value="MoveToNext">Move To Next</Option>
              <Option value="JumpToStage">Jump To Stage</Option>
              <Option value="Reject">Reject</Option>
              <Option value="Sendback">Sendback</Option>
            </Select>
            <br></br>
            <input
              type="text"
              placeholder="Stage System Name"
              value={newInput1}
              onChange={(e) => setNewInput1(e.target.value)}
              style={{ padding: "5px", width: "150px" }}
            />
          </Modal>

   
      </div>

      <h4>Tasks</h4>

      {tasks.length === 0 ? (
        <p>No tasks found.</p>
      ) : (
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: "10px",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#f2f2f2" }}>
              <th style={thStyle}>ID</th>
              <th style={thStyle}>User ID</th>
              <th style={thStyle}>Title</th>
              <th style={thStyle}>Due Date</th>
              <th style={thStyle}>Status</th>
              <th style={thStyle}>WF Instance</th>
              <th style={thStyle}>Remarks</th>
              <th style={thStyle}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {tasks.map((task) => {
              const statusText =
                taskStatusMapById[task.taskStatusId] || "Unknown";
              const isPending = statusText === "Pending";

              return (
                <tr
                  key={task.taskId ? `task-${task.taskId}` : `id-${task.Id}`}
                  style={{ cursor: "pointer" }}
                >
                  <td style={tdStyle}>{task.taskId ?? task.Id}</td>
                  <td style={tdStyle}>{task.userId ?? task.Id}</td>
                  <td style={tdStyle}>{task.title}</td>
                  <td style={tdStyle}>
                    {new Date(task.dueDate).toLocaleString()}
                  </td>
                  <td style={tdStyle}>{statusText}</td>
                  <td style={tdStyle}>{task.workflowInstanceId}</td>
                  <td style={tdStyle}>{task.remarks}</td>
                  <td style={tdStyle}>
                    {isPending && (
                      <>
                        <button
                          onClick={() =>
                            UpdateTask(task.taskId ?? task.Id, "Completed", 0)
                          }
                        >
                          Complete
                        </button>
                        <button
                          onClick={() =>
                            UpdateTask(task.taskId ?? task.Id, "Rejected", 0)
                          }
                          style={{ marginLeft: "10px", color: "red" }}
                        >
                          Reject
                        </button>
                        <button
                          onClick={() =>
                            SendbackTask(task.taskId ?? task.Id, "Sendback", 0)
                          }
                          style={{ marginLeft: "10px", color: "blue" }}
                        >
                          Send Back
                        </button>
                      </>
                    )}
                  </td>

                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

const thStyle: React.CSSProperties = {
  border: "1px solid #dfc9c9ff",
  padding: "8px",
  textAlign: "left",
};

const tdStyle: React.CSSProperties = {
  border: "1px solid #ddd",
  padding: "8px",
};

export default WorkflowScreen;